/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TChangeOffersOrderRequest,
  TChangeOffersOrderModel,
  IMappers,
  TChangeOffersOrderResponse,
  TChangeOffersOrderResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createChangeOffersOrderModel(parameters: TChangeOffersOrderRequest): TChangeOffersOrderModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'offers-comparison',
    pathApi: '/v1/change-offers-order/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IChangeOffersOrderOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TChangeOffersOrderRequest;
}

export async function fetchChangeOffersOrder<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IChangeOffersOrderOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TChangeOffersOrderResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createChangeOffersOrderModel(parameters),
    config,
  )) as FetchResponse<TChangeOffersOrderResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TChangeOffersOrderResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TChangeOffersOrderResponse>;
}
